var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { axiosPrivate } from "../../api/axios";
/**
 * Axios Private fetcher function for SWR. A regular axios request / function can be used as well.
 * See useSkipDays.tsx for usage.
 * @param url
 * @returns
 */
export const apFetcher = (url) => () => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield axiosPrivate.get(url);
    return res.data;
});
